export default defineNuxtPlugin(async (nuxtApp) => {
    const headers = useRequestHeaders(['cookie']);
    const { isDraftModeEnabled } = useDraftMode();
    const { data, error } = await useFetch<StoryblokConfigSlug[]>('/api/section-registry', {
        key: computed(() => `section-registry-${isDraftModeEnabled.value ? 'draft' : 'published'}`),
        headers
    });

    if (error.value) {
        throw createError({
            statusCode: error.value.statusCode,
            message: error.value.message,
            fatal: true
        });
    }

    const configSlugs = useState<StoryblokConfigSlug[] | null>('sub-section-registry', () => null);

    // Keep app-wide navigation data when Nuxt disposes the fetch during an external redirect.
    nuxtApp.runWithContext(() => {
        watch(
            data,
            (registry) => {
                if (registry !== undefined) configSlugs.value = registry;
            },
            { immediate: true }
        );
    });

    nuxtApp.provide('subSectionRegistry', configSlugs);
});
